import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const GetToken: React.FC = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (token) {
      navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!token) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>❌ Not Logged In</h2>
        <p>Please log in first to get your token.</p>
        <button onClick={() => navigate('/login')}>Go to Login</button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>🔑 Your Auth Token</h2>
      <p>Copy this token to use in your iOS Shortcut:</p>
      
      <div style={{
        background: '#f5f5f5',
        padding: '15px',
        borderRadius: '8px',
        marginTop: '20px',
        marginBottom: '20px',
        wordBreak: 'break-all',
        fontFamily: 'monospace',
        fontSize: '12px'
      }}>
        {token}
      </div>

      <button 
        onClick={handleCopy}
        style={{
          padding: '12px 24px',
          background: copied ? '#4CAF50' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          marginRight: '10px'
        }}
      >
        {copied ? '✅ Copied!' : '📋 Copy Token'}
      </button>

      <button 
        onClick={() => navigate('/submit-expense')}
        style={{
          padding: '12px 24px',
          background: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        ← Back
      </button>

      <div style={{
        marginTop: '30px',
        padding: '15px',
        background: '#fff3cd',
        borderRadius: '8px',
        borderLeft: '4px solid #ffc107'
      }}>
        <h3>⚠️ Security Note</h3>
        <p style={{ margin: '10px 0', fontSize: '14px' }}>
          This token gives full access to your account. Only use it in your personal iOS Shortcut.
          Never share it with anyone else.
        </p>
        <p style={{ margin: '10px 0', fontSize: '14px' }}>
          If you suspect your token has been compromised, log out and log back in to generate a new one.
        </p>
      </div>
    </div>
  );
};

export default GetToken;
